(function () {
    'use strict';

    angular.module('app').controller('ClientLocationController',
        function (
            $scope,
            Units,
            ClientService,
            $routeParams,
            $location,
            Location,
            Currency,
            aborter,
            Timezone,
            toastr,
            ConfirmationModalFactory,
            ClientsListsRepositoryFactory,
            $timeout,
            $q,
            $filter,
            scrollToForm,
            ViewChangeNotificationFactory,
            isUniqueService,
            $uibModal,
            $rootScope,
            ClientOfficeSchedulePickupsTable,
            ResellerListTable
        ) {

            let vm = this;
            let noParent = {
                id: null,
                name: "No Parent Location"
            };

            vm.defaultCurrency = $rootScope.GlobalProfile.office.currency;
            vm.defaultMeasureUnit = $rootScope.GlobalProfile.office.measureUnit;
            vm.defaultWeightUnit = $rootScope.GlobalProfile.office.weightUnit;

            vm.units = UNITS.combined;
            vm.clientsLists = ClientsListsRepositoryFactory;
            vm.params = $routeParams || {};
            vm.locationId = vm.params.locationId || undefined;
            vm.companyId = vm.params.companyId || undefined;
            vm.unitsList = Units;
            vm.goTo = goTo;
            vm.save = save;
            vm.countries = [];
            vm.postCodes = [];
            vm.location = {
                driverDirectSetting: {},
                defaultDimensions: {
                    enableDefaultDimension: false
                }
            };
            vm.locationRaw = angular.copy(vm.location);
            vm.currencies = [];
            vm.fetching = {};
            vm.isUnique = isUnique;
            vm.origOfficeName = undefined;
            vm.origEmail = undefined;
            vm.timezones = Timezone.getTimeZones();
            vm.officeTypes = [
                { name: 'Warehouse', value: 'Warehouse' },
                { name: 'Cross Dock', value: 'Crossdock' },
                { name: 'Third Party Logistics', value: 'ThirdPartyLogistics' },
            ];

            vm.searchForZipcode = searchForZipcode;
            vm.searchForCountry = searchForCountry;
            vm.selectCountry = selectCountry;
            vm.selectParent = selectParent;
            vm.selectPostCode = selectPostCode;
            vm.removeSchedTime = removeSchedTime;
            vm.selectLocationProfilePostCode = selectLocationProfilePostCode;
            vm.selectLocationProfileCountry = selectLocationProfileCountry;
            vm.isViewMode = false;
            vm.changeStatus = changeStatus;
            vm.copyDetails = copyDetails;
            vm.showAddSchedModal = showAddSchedModal;
            vm.onMeasureSelect = onMeasureSelect;
            vm.onSelectOfficeType = onSelectOfficeType;
            vm.searchForLocations = searchForLocations;
            vm.init = init;

            vm.schedModalForm = {};
            vm.networkSwitch = {
                true: $filter('translate')('labels.switch.ENABLE'),
                false: $filter('translate')('labels.switch.DISABLE'),
            };

            $scope.cancelAddingTimeSlot = function () {
                resetFormSlot();
            };

            function showAddSchedModal(sched, index) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/client/location/ScheduledPickupModal.html',
                    controller: 'ScheduledPickupModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        schedule: function () {
                            return angular.copy(angular.extend(sched, { index }))
                        }
                    }
                });

                modalInstance.result.then(function (data) {
                    if (angular.isDefined(data.index) && angular.getObjVal(vm, 'location.scheduledPickups.length')) {
                        vm.location.scheduledPickups[data.index] = data;
                    } else {
                        vm.location.scheduledPickups.push(data);
                    }
                }, function () {
                });

                vm.schedModalForm.frequency = angular.copy(vm.weekDays);
            }

            const viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.viewChange.MESSAGE',
                code: 'messages.warning.viewChange.CODE',
            });
            const toInactiveConf = new ConfirmationModalFactory({}, {
                message: 'messages.warning.statusChange.MESSAGE.TO_LOCATION_INACTIVE',
                code: 'messages.warning.statusChange.CODE'
            });

            const toActiveConf = new ConfirmationModalFactory({}, {
                message: 'messages.warning.statusChange.MESSAGE.TO_LOCATION_ACTIVE',
                code: 'messages.warning.statusChange.CODE'
            });
            let initParent = (data, parentId) => {
                return data.content.find(loc => {
                    if (loc) {
                        return loc.id === parentId;
                    }
                }) || noParent;
            };
            let getCurrencies = $q((resolve, reject) => {
                Currency.getList((data) => resolve(data), (error) => reject(error));
            });
            let setDefaultMeasure = (weightUnit) => {
                const defaultMeasureUnit = vm.units.find(unit => {
                    return unit.values.weightUnit.toLowerCase() === vm.defaultWeightUnit.toLowerCase()
                });

                if (defaultMeasureUnit) {
                    vm.location.units = defaultMeasureUnit;
                    vm.location.measureUnit = defaultMeasureUnit.values.measureUnit;
                    vm.location.weightUnit = defaultMeasureUnit.values.weightUnit;
                } else {
                    vm.location.units = vm.units.find((unit) => unit.values.weightUnit.toLowerCase() === weightUnit.toLowerCase());
                }
                vm.weightUnitAbbr = vm.unitsList.weightUnit.find(val => val.value.toLowerCase() === vm.location.weightUnit.toLowerCase());
            };
            const setOfficeType = function (officeTypeParam) {
                let index = 0;
                vm.officeTypes.forEach(function (officeType, i) {
                    if (officeType.value === officeTypeParam) {
                        index = i;
                    }
                });
                vm.location.officeType = vm.officeTypes[index];
            };
            init();

            function getCurrenciesQ() {
                const defer = $q.defer();
                getCurrencies.then((currencies) => {
                    const defaultCurrency = currencies.find(cur => {
                        return cur.currencyCode.toLowerCase() === vm.defaultCurrency.toLowerCase();
                    });

                    if (defaultCurrency) {
                        vm.location.defaultCurrency = defaultCurrency;
                        vm.location.currency = defaultCurrency.defaultCurrency;
                    } else {
                        vm.location.defaultCurrency = currencies.find((currency) => {
                            return currency.currencyCode === vm.location.currency;
                        });
                    }

                    vm.currencies = currencies;
                    vm.isFetching = false;
                    defer.resolve(currencies);
                }).catch(error => defer.reject(error));
                return defer.promise;
            }

            function init() {
                const scheduledPickups = [];
                setIsAdmin();

                if (vm.locationId) {
                    vm.isFetching = true;

                    ClientService.Location.get({ 'company.id': vm.locationId }, function (data) {
                        vm.location = angular.copy(data);
                        angular.extend(vm.location, { scheduledPickups });
                        vm.origOfficeName = vm.location.name;
                        vm.origEmail = vm.location.email;
                        vm.copyOfficeDetails = [
                            vm.location.locationProfile.firstName === vm.location.firstName,
                            vm.location.locationProfile.lastName === vm.location.lastName,
                            vm.location.locationProfile.email === vm.location.email,
                            vm.location.locationProfile.phone1 === vm.location.phone1,
                            vm.location.locationProfile.phone2 === vm.location.phone2,
                            vm.location.locationProfile.address1 === vm.location.addressLine1,
                            vm.location.locationProfile.address2 === vm.location.addressLine2,
                            angular.equals(vm.location.locationProfile.location, vm.location.location),
                        ].every((e) => {
                            return e === true
                        });


                        const clientOfficeSchedulePickupsTable = new ClientOfficeSchedulePickupsTable({ id: data.id });
                        vm.clientOfficeSchedulePickupsTable = clientOfficeSchedulePickupsTable.tableData;
                        setAccountsContactDetails();
                        initTImezone(vm.location);
                        initDriverDirect(vm.location.driverDirectSetting);
                        setDefaultMeasure(vm.location.weightUnit);
                        setOfficeType(vm.location.officeType);
                        initResellersTableData();
                        $q.all({
                            currencies: getCurrenciesQ(),
                            parentMatch: searchForLocations({ open: true, name: '' }, vm.location.parent || '')
                        }).then(data => {
                            vm.location.parent = initParent(vm.clientsLists.lists.locations, vm.location.parent || '');
                            vm.locationRaw = angular.copy(vm.location);

                        })
                    });
                }
                else {
                    initTImezone(vm.location);
                    setDefaultMeasure();
                    setOfficeType('Warehouse');
                    setDriverDirectDefaults(vm.location.driverDirectSetting);
                    initResellersTableData();
                    getCurrencies.then((currencies) => {
                        const currency = currencies.find(cur => {
                            return cur.currencyCode.toLowerCase() === vm.defaultCurrency.toLowerCase()
                        });
                        vm.location.defaultCurrency = currency;
                        vm.location.currency = currency.currencyCode;
                        vm.currencies = currencies;
                        vm.locationRaw = angular.copy(vm.location);
                    });
                    angular.extend(vm.location, { scheduledPickups });
                }
                if (!vm.clientsLists.lists.locations.content) {
                    vm.clientsLists.lists.locations.update({ 'company.id': vm.companyId });
                }
            }

            function setIsAdmin() {
                const isFound = $rootScope.GlobalProfile.permissionGroup.roles.find(role => role.code === 'ROLE_ADMIN');
                vm.isAdmin = !!isFound;
            }

            function initResellersTableData() {

                const sharedResellers = angular.getObjVal(vm.location, 'networkEffect.sharedToResellers') ? vm.location.networkEffect.sharedToResellers : [];
                const resellers = sharedResellers.map(data => {
                    return {
                        resellerId: data
                    }
                });

                vm.resellers = new ResellerListTable(resellers);
                vm.resellersData = vm.resellers.tableData;
            }

            function setAccountsContactDetails() {
                if (checkIfFieldIsAutoGenerated(vm.location.locationProfile.firstName) || checkIfFieldIsAutoGenerated(vm.location.locationProfile.lastName)) {
                    vm.location.locationProfile.firstName = vm.location.firstName;
                    vm.location.locationProfile.lastName = vm.location.lastName;
                    vm.location.locationProfile.email = vm.location.email;
                    vm.location.locationProfile.phone1 = vm.location.phone1;
                    vm.location.locationProfile.phone2 = vm.location.phone2;
                    vm.location.locationProfile.address1 = vm.location.addressLine1;
                    vm.location.locationProfile.address2 = vm.location.addressLine2;
                }
            }

            function checkIfFieldIsAutoGenerated(fieldValue) {
                const defaultValue = 'Automatically';
                return fieldValue.includes(defaultValue);
            }

            function setDriverDirectDefaults(service) {
                return angular.extend(service, {
                    unattendedPodPicture: true,
                    customerSignature: true,
                    shipmentRestrictions: 'both'
                });
            }

            function initDriverDirect(service) {
                service.disableAutoJobAssignment = !service.autoJobAssignationEnabled;
                service.shipmentRestrictions = service.shipmentRestrictions || service.shipmentTypes &&
                    ((service.shipmentTypes.length !== 2 && service.shipmentTypes.length) ? service.shipmentTypes[0].name || service.shipmentTypes[0] : 'both');
            }

            function initTImezone(office) {
                if (office.officeConfiguration) {
                    if (office.officeConfiguration.timeZone) {
                        office.officeConfiguration.timeZone = vm.timezones.find(function (tz) {
                            return tz.value === office.officeConfiguration.timeZone || tz.value === office.officeConfiguration.timeZone.value;
                        });
                    } else {
                        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        office.officeConfiguration.timeZone = vm.timezones.find(tz => tz.value === userTimezone) || vm.timezones[0];
                    }
                } else {
                    office.officeConfiguration = {};
                    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    office.officeConfiguration.timeZone = vm.timezones.find(tz => tz.value === userTimezone) || vm.timezones[0];
                }
            }
            function onMeasureSelect(selected) {
                vm.location.measureUnit = selected.values.measureUnit;
                vm.location.weightUnit = selected.values.weightUnit;
                vm.weightUnitAbbr = vm.unitsList.weightUnit.find(val => val.value.toLowerCase() === selected.values.weightUnit.toLowerCase());
            }
            function onSelectOfficeType(selected) {
                vm.location.officeType = selected;
            }
            function searchForLocations(select, id) {
                const defer = $q.defer();
                if (select.open) {
                    vm.clientsLists.lists.locations.content = [];
                    vm.fetching.locations = true;
                    aborter(() => {
                        vm.clientsLists.lists.locations.update({
                            company: vm.companyId,
                            name: select.search,
                            id
                        }).then(data => {
                            data.content.unshift(noParent);
                            defer.resolve(data);
                            delete vm.fetching.locations;
                        }).catch(error => {
                            defer.reject(error);
                            delete vm.fetching.locations;
                        });
                    }, 500);
                }
                return defer.promise;
            }

            function removeSchedTime(i) {
                vm.dummyScheduledPickupTimes.splice(i, 1);
            }

            function searchForCountry(country = '', size = 200) {
                return $q((resolve, reject) => {
                    Location.Country({
                        name: country,
                        size
                    }, function (data) {
                        vm.countries = data;
                        resolve(data);
                        if (data.length <= 0) {
                            vm.countries = [{
                                name: 'No Search Result'
                            }];
                            reject(vm.countries)
                        }
                    }, function (err) {
                        vm.countries = [{
                            name: 'No Search Result'
                        }];
                        reject(vm.countries)
                    })
                });
            }

            function searchForZipcode(code = '', country = { code: '' }, size = 200) {
                return $q((resolve, reject) => {
                    Location.ZipCode({
                        country: country.code,
                        size,
                        sort: 'code',
                        code
                    }, function (data) {
                        vm.postCodes = data.content;
                        resolve(data.content);
                        if (!data.content.length) {
                            vm.postCodes = [{
                                code: 'No post code found'
                            }];
                            reject(vm.postCodes)
                        }
                    }, function (err) {
                        vm.postCodes = [{
                            code: 'No post code found'
                        }];
                        reject(vm.postCodes)
                    })
                });
            }

            function selectParent(item, model) {
                vm.location.parentId = item ? item.id : null;
            }

            function selectCountry(item, model) {
                if (item.code) {
                    angular.extend(vm.location, {
                        location: {
                            country: item
                        }
                    });
                    searchForZipcode(undefined, vm.location.location.country);
                }
            }

            function selectPostCode(item) {
                // vm.postCodes = [];

                if (!item.code) {
                    vm.location.postCode = {};
                    vm.location.suburb = '';
                    vm.location.state = '';
                } else {
                    vm.location.suburb = item.name;
                    vm.location.state = item.state ? item.state.name : '';
                }
            }

            function selectLocationProfileCountry(item, model) {
                if (item.code) {
                    angular.extend(vm.location.locationProfile, {
                        location: {
                            country: item
                        }
                    });
                    selectLocationProfilePostCode(undefined, vm.location.locationProfile.location.country);
                }
            }

            function selectLocationProfilePostCode(item) {
                // vm.postCodes = [];

                if (!item.code) {
                    vm.location.locationProfile.postCode = {};
                    vm.location.locationProfile.suburb = '';
                    vm.location.locationProfile.state = '';
                } else {
                    vm.location.locationProfile.suburb = item.name;
                    vm.location.locationProfile.state = item.state ? item.state.name : '';
                }
            }

            function copyDetails() {
                if (vm.copyOfficeDetails) {
                    if (!vm.location.locationProfile) vm.location.locationProfile = {};
                    $timeout(function () {
                        vm.location.locationProfileRaw = angular.copy(vm.location.locationProfile);
                        vm.location.locationProfile.firstName = angular.copy(vm.location.firstName);
                        vm.location.locationProfile.lastName = angular.copy(vm.location.lastName);
                        vm.location.locationProfile.email = angular.copy(vm.location.email);
                        vm.location.locationProfile.phone1 = angular.copy(vm.location.phone1);
                        vm.location.locationProfile.phone2 = angular.copy(vm.location.phone2);
                        vm.location.locationProfile.address1 = angular.copy(vm.location.addressLine1);
                        vm.location.locationProfile.address2 = angular.copy(vm.location.addressLine2);
                        vm.location.locationProfile.location = angular.copy(vm.location.location);
                    });
                } else {
                    if (vm.location.locationProfileRaw)
                        vm.location.locationProfile = angular.copy(vm.location.locationProfileRaw);
                }
            }

            function save(...forms) {
                const validForms = forms.every((form) => {
                    form.$setSubmitted();
                    if (form.$invalid) {
                        scrollToForm(form.$name);
                    }
                    return form.$valid;
                });
                if (!validForms) {
                    /*toastr.warning('Error saving', 'Please check the forms for invalid input');*/
                    return;
                }

                const payload = cleanPayload(vm.location);

                vm.savingData = true;
                if (vm.locationId) {
                    ClientService.Location.update(payload, function (response) {
                        vm.locationId = response.id;
                        vm.locationRaw = angular.copy(vm.location);
                        toastr.success("Location/Office has been updated");
                        vm.savingData = false;
                    }, function (error) {
                        toastr.error(error.message || 'Contact administrator if this error will occur again');
                        vm.savingData = false;
                    }, vm.locationId);
                } else {
                    ClientService.Location.create(payload, function (response) {
                        onRouteChangeOff();
                        $location.path(`clients/${vm.companyId}/location/${response.id}`);
                        toastr.success("Location/Office has been created");
                        vm.savingData = false;
                    }, function (error) {
                        toastr.error(error.message || 'Contact administrator if this error will occur again');
                        vm.savingData = false;
                    });
                }
            }

            function cleanPayload(requestData) {
                const {
                    driverDirectEnabled,
                    maxCarryOnWeightPerPerson,
                    driverCommissionFixed,
                    driverCommissionPercentage,
                    smsNotification,
                    emailNotification,
                    callCustomer,
                    unattendedPodPicture,
                    customerSignature,
                    requiredPackageScanning,
                    keepPackageUntilRedelivery,
                    p2pEnabled,
                    shipmentRestrictions,
                    maxJob,
                    disableAutoJobAssignment,
                    jobSplittingEnabled,
                    pickupFeeEnabled,
                    minPickupFee
                } = requestData.driverDirectSetting;
                let payload = {
                    quoteInMeter: requestData.quoteInMeter,
                    receiverCode: requestData.receiverCode,
                    senderCode: requestData.senderCode,
                    currency: requestData.defaultCurrency.currencyCode,
                    measureUnit: requestData.measureUnit,
                    weightUnit: requestData.weightUnit,
                    officeConfiguration: {
                        automatedReturn: requestData.officeConfiguration.automatedReturn,
                        breakBulkManifesting: requestData.officeConfiguration ? requestData.officeConfiguration.breakBulkManifesting : false,
                        containerizationEnabled: requestData.officeConfiguration ? requestData.officeConfiguration.containerizationEnabled : false,
                        crossDockStraightThroughEnabled: (requestData.officeType.value === 'Crossdock' ? requestData : vm.locationRaw).officeConfiguration.crossDockStraightThroughEnabled || false,
                        jobDeliveredToScanCrossDockShipmentEnabled: (requestData.officeType.value === 'Crossdock' ? requestData : vm.locationRaw).officeConfiguration.jobDeliveredToScanCrossDockShipmentEnabled || false,
                        crossDockManifestingEnabled: (requestData.officeType.value === 'Crossdock' ? requestData : vm.locationRaw).officeConfiguration.crossDockManifestingEnabled || false,
                        manifesting: requestData.officeConfiguration ? requestData.officeConfiguration.manifesting : false,
                        emailTrackingToReceiver: requestData.officeConfiguration ? requestData.officeConfiguration.emailTrackingToReceiver : false,
                        satchelOnlyInQuote: requestData.officeConfiguration ? requestData.officeConfiguration.satchelOnlyInQuote : false,
                        ddp: requestData.officeConfiguration ? requestData.officeConfiguration.ddp : false,
                        thermal: requestData.officeConfiguration ? requestData.officeConfiguration.thermal : false,
                        timeZone: angular.getObjVal(requestData, 'officeConfiguration.timeZone.value') || null,
                        creditLimit: requestData.officeConfiguration ? requestData.officeConfiguration.creditLimit : null,
                        scheduledPickup: requestData.officeConfiguration ? requestData.officeConfiguration.manifesting : false,
                        smsNotificationEnabled: requestData.officeConfiguration ? requestData.officeConfiguration.smsNotificationEnabled : false,
                        instructionsDocumentEnabled: requestData.officeConfiguration ? requestData.officeConfiguration.instructionsDocumentEnabled : false,
                        createPickupJob: requestData.officeConfiguration ? requestData.officeConfiguration.createPickupJob : false,
                        paperlessTradingEnabled: requestData.officeConfiguration ? requestData.officeConfiguration.paperlessTradingEnabled : false,
                        generateSSCCLabel: requestData.officeConfiguration ? requestData.officeConfiguration.generateSSCCLabel : false,
                        pickSlipDisplayCrates: requestData.officeConfiguration ? requestData.officeConfiguration.pickSlipDisplayCrates : false,
                        pickSlipHideSender: requestData.officeConfiguration ? requestData.officeConfiguration.pickSlipHideSender : false,
                        printLabel: requestData.officeConfiguration ? requestData.officeConfiguration.printLabel : false,
                        enableBreakBulkMilestoneManifesting: requestData.officeConfiguration ? requestData.officeConfiguration.enableBreakBulkMilestoneManifesting : false,
                        hideBookingSuccessful: requestData.officeConfiguration ? requestData.officeConfiguration.hideBookingSuccessful : false,
                    },
                    locationProfile: {
                        address1: !angular.isUndefined(requestData.locationProfile) ? requestData.locationProfile.address1 : '',
                        address2: !angular.isUndefined(requestData.locationProfile) ? requestData.locationProfile.address2 : '',
                        firstName: !angular.isUndefined(requestData.locationProfile) ? requestData.locationProfile.firstName : '',
                        lastName: !angular.isUndefined(requestData.locationProfile) ? requestData.locationProfile.lastName : '',
                        phone2: !angular.isUndefined(requestData.locationProfile) ? requestData.locationProfile.phone2 : '',
                        phone1: !angular.isUndefined(requestData.locationProfile) ? requestData.locationProfile.phone1 : '',
                        email: !angular.isUndefined(requestData.locationProfile) ? requestData.locationProfile.email : '',
                        location: angular.getObjVal(requestData, 'location.id')
                    },
                    description: requestData.description,
                    notificationPreferences: {
                        notifyQuoteAndBook: !angular.isUndefined(requestData.notificationPreferences) ? requestData.notificationPreferences.notifyQuoteAndBook : false,
                        notifyPendingShipment: !angular.isUndefined(requestData.notificationPreferences) ? requestData.notificationPreferences.notifyPendingShipment : false,
                        notifyReturns: !angular.isUndefined(requestData.notificationPreferences) ? requestData.notificationPreferences.notifyReturns : false,

                    },
                    code: requestData.code,
                    firstName: requestData.firstName,
                    lastName: requestData.lastName,
                    phone2: requestData.phone2,
                    addressLine1: requestData.addressLine1,
                    addressLine2: requestData.addressLine2,
                    phone1: requestData.phone1,
                    website: requestData.website,
                    active: !!requestData.active,
                    email: requestData.email,
                    name: requestData.name,
                    officeType: requestData.officeType.value,
                    companyId: vm.companyId,
                    parentId: angular.getObjVal(requestData, 'parent.id'),
                    driverDirectSetting: {
                        driverDirectEnabled: !!driverDirectEnabled,
                        maxCarryOnWeightPerPerson,
                        driverCommissionFixed,
                        driverCommissionPercentage,
                        smsNotification: !!smsNotification,
                        emailNotification: !!emailNotification,
                        callCustomer: !!callCustomer,
                        unattendedPodPicture: !!unattendedPodPicture,
                        customerSignature: !!customerSignature,
                        requiredPackageScanning: !!requiredPackageScanning,
                        keepPackageUntilRedelivery: !!keepPackageUntilRedelivery,
                        returnPackageToDepot: !keepPackageUntilRedelivery,
                        p2pEnabled: !!p2pEnabled,
                        maxJob,
                        shipmentType: shipmentRestrictions === 'both' ? '' : shipmentRestrictions,
                        autoJobAssignationEnabled: !disableAutoJobAssignment,
                        jobSplittingEnabled: !jobSplittingEnabled,
                        pickupFeeEnabled: pickupFeeEnabled || false,
                        minPickupFee: minPickupFee || 0
                    },
                    goodsCheck: generateGoodsCheckValue(),
                    networkEffect: {
                        sharedToResellers: generateResellerIds(),
                        enabled: requestData.networkEffect ? requestData.networkEffect.enabled : null
                    }
                };

                if (requestData.location) {
                    payload.location = angular.getObjVal(requestData, 'location.id');
                }

                if (!angular.isUndefined(requestData.defaultDimensions)) {
                    payload.defaultDimensions = {};
                    payload.defaultDimensions.enableDefaultDimension = requestData.enableDefaultDimension;
                    payload.defaultDimensions.defaultHeight = !angular.isUndefined(requestData.defaultDimensions.defaultHeight) ? requestData.defaultDimensions.defaultHeight : 0,
                        payload.defaultDimensions.defaultLength = !angular.isUndefined(requestData.defaultDimensions.defaultLength) ? requestData.defaultDimensions.defaultLength : 0,
                        payload.defaultDimensions.defaultWidth = !angular.isUndefined(requestData.defaultDimensions.defaultWidth) ? requestData.defaultDimensions.defaultWidth : 0,
                        payload.defaultDimensions.defaultWeight = !angular.isUndefined(requestData.defaultDimensions.defaultWeight) ? requestData.defaultDimensions.defaultWeight : 0
                }

                return payload;
            }

            function generateResellerIds() {
                console.log(vm.resellers.getSelectedRows());
                return vm.resellers.getSelectedRows().map(data => data.id);
            }

            function generateGoodsCheckValue() {
                angular.getObjVal(vm.location, 'goodsCheck.accompaniedDelivery')
                return {
                    accompaniedDelivery: angular.getObjVal(vm.location, 'goodsCheck.accompaniedDelivery') || false,
                    clientPresent: angular.getObjVal(vm.location, 'goodsCheck.clientPresent') || false,
                    dangerousGoods: angular.getObjVal(vm.location, 'goodsCheck.dangerousGoods') || false,
                    fragile: angular.getObjVal(vm.location, 'goodsCheck.fragile') || false,
                    handUnload: angular.getObjVal(vm.location, 'goodsCheck.handUnload') || false,
                    poBox: angular.getObjVal(vm.location, 'goodsCheck.poBox') || false,
                    residentialDelivery: angular.getObjVal(vm.location, 'goodsCheck.residentialDelivery') || false,
                    residentialPickup: angular.getObjVal(vm.location, 'goodsCheck.residentialPickup') || false,
                    tailGateDelivery: angular.getObjVal(vm.location, 'goodsCheck.tailGateDelivery') || false,
                    tailGatePickup: angular.getObjVal(vm.location, 'goodsCheck.tailGatePickup') || false,
                    trolleyRequired: angular.getObjVal(vm.location, 'goodsCheck.trolleyRequired') || false,
                    unattendedDelivery: angular.getObjVal(vm.location, 'goodsCheck.unattendedDelivery')
                }
            }

            function changeStatus(event) {
                if (!vm.location.active) {
                    vm.location.active = true;
                    event.preventDefault();
                    toInactiveConf.getInstance().result.then(function (cond) {
                        if (cond) {
                            $timeout(function () {
                                vm.location.active = false;
                            });
                        }
                    });
                } else if (vm.location.active) {
                    vm.location.active = false;
                    event.preventDefault();
                    toActiveConf.getInstance().result.then(function (cond) {
                        if (cond) {
                            $timeout(function () {
                                vm.location.active = true;
                            });
                        }
                    });
                }
            }
            function goTo(path, params) {
                $location.path(path).search(params);
            }

            let onRouteChangeOff = $rootScope.$on('$routeChangeStart', routeChange);
            function routeChange(event, next, current) {
                let path = next.$$route.originalPath.replace(':companyId', next.pathParams.companyId);
                if (!vm.isViewMode && !angular.equals(cleanPayload(vm.location), cleanPayload(vm.locationRaw))) {
                    event.preventDefault();
                    viewConfirmation.getInstance().result.then(function (cond) {
                        if (cond) {
                            onRouteChangeOff();
                            $location.path(path).search({ tab: next.params.tab });
                        }
                    });
                }
            }
            function isUnique(model, formField, origVal, prop) {
                let params = {};
                params.model = model;
                params.origName = origVal;
                params.formField = formField;
                params.service = ClientService.Location;
                params.serviceMethod = "getAll";
                params.property = prop;
                params.warningMsg = `${prop} is already taken`;
                isUniqueService.isUnique(params);
            }
        });
})();



// WEBPACK FOOTER //
// ./js/controllers/client/ClientLocationController.js